import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const bullet = ' \u2022 '

export default function Title({ children = '', breadcrumbs = '' }) {
  // This filter works for one or more children
  const title = [...children].filter((child) => child !== undefined).join('')
  const normalizedBreadCrumbs = Array.isArray(breadcrumbs) ? breadcrumbs : breadcrumbs.split(',')

  const titleWithBreadCrumbs = normalizedBreadCrumbs
    .map((crumb) => crumb.trim())
    .filter(Boolean)
    .concat([title])
    .reverse()
    .join(bullet)

  return (
    <Helmet defer={false}>
      <title>{children ? titleWithBreadCrumbs : 'FamilySearch'}</title>
    </Helmet>
  )
}

Title.propTypes = {
  // Breadcrumbs prop can be a comma separated string or an array
  breadcrumbs: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
}
